import { ContractType } from "data/store/TokenStore";

const AVG_ABI = [
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];

export const AVG_CONTRACT: ContractType = {
  address: "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
  unit: "ether",
  abi: AVG_ABI,
};
